import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundView.scss';

const NotFoundView = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-image">
          <img src="/img/404.jpg" alt="404" onError={(e) => e.target.src = "https://static.vecteezy.com/system/resources/thumbnails/011/626/292/small/404-error-page-not-found-free-png.png"} />
        </div>
        <h1>Página no encontrada</h1>
        <p>Lo sentimos, la página que estás buscando no existe o ha sido movida.</p>
        <div className="not-found-actions">
          <Link to="/dashboard" className="btn btn-primary">
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundView; 